import type { CallbackEvent } from "@shopify/polaris-types";

/**
 * Search input for sales-booster list pages. Lives inside an
 * `s-section padding="none"` so it provides its own padded container, giving
 * the standard Shopify list look (padded search row above the flush table).
 *
 * No inline clear/"Limpiar" button — clearing surfaces in the empty-search
 * state ("Limpiar búsqueda" recovery action), where it's actually useful.
 */
export function ListSearchBar({
  value,
  onChange,
}: {
  value: string;
  onChange: (q: string) => void;
}) {
  return (
    <>
      <s-box padding="base">
        <s-text-field
          placeholder="Buscar por nombre..."
          value={value}
          onInput={(e: CallbackEvent<"s-text-field">) =>
            onChange(e.currentTarget.value)
          }
        />
      </s-box>
    </>
  );
}
